'use es6';

import { getConfigsWithSuiteIfPossible, getCheckoutProductConfigurations, getProductLevelInConfigs, getSuiteProductConfigurations, getConfigurationsWithPBORequiredOnboarding, getProductVersionConfigsWithUnits, getOfferProductConfigurations, getNonRecurringProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { productForSkuIdSelector, productSelector, skuSelector } from './ProductsSelectors';
import { transformState } from './SelectorUtils';
export const productVersionFromConfigsSelector = (state, {
  productConfigurations,
  productLine
}) => {
  for (let i = 0; i < productConfigurations.length; i++) {
    const {
      productId,
      productVersionSkuId,
      skuId
    } = skuSelector(state, {
      skuId: productConfigurations[i].skuId
    });
    const {
      productLine: tempProductLine
    } = productSelector(state, {
      productId
    });

    if (tempProductLine === productLine) {
      // If the sku we selected is a quantity pack, it will have this field
      if (productVersionSkuId) {
        return skuSelector(state, {
          skuId: productVersionSkuId
        });
      }

      return skuSelector(state, {
        skuId
      });
    }
  }

  return null;
};
export const checkoutProductConfigurationsSelector = createSelectorFromUtil(getCheckoutProductConfigurations, transformState);
export const productLevelInConfigsSelector = createSelectorFromUtil(getProductLevelInConfigs, transformState);
export const suiteProductConfigurationsSelector = createSelectorFromUtil(getSuiteProductConfigurations, transformState);
export const configsWithSuiteIfPossibleSelector = createSelectorFromUtil(getConfigsWithSuiteIfPossible, transformState);
export const configurationsWithPBORequiredOnboardingSelector = createSelectorFromUtil(getConfigurationsWithPBORequiredOnboarding, transformState);
/**
 * @see getProductVersionConfigsWithUnits
 */

export const productVersionConfigsWithUnitsSelector = createSelectorFromUtil(getProductVersionConfigsWithUnits, transformState);
export const getFirstHubSkuIdFromProductConfigurations = (state, {
  productConfigurations
}) => {
  const foundProductConfig = productConfigurations.find(({
    skuId
  }) => {
    const {
      productLine,
      productLevel
    } = productForSkuIdSelector(state, {
      skuId
    });
    return productLine && productLevel;
  });
  if (!foundProductConfig) return null;
  const foundSku = skuSelector(state, {
    skuId: foundProductConfig.skuId
  });
  let foundSkuId;
  const {
    skuType
  } = foundSku;
  if (skuType === QUANTITY_PACK) foundSkuId = foundSku.productVersionSkuId;else foundSkuId = foundSku.skuId;
  return foundSkuId;
};
export const offerProductConfigurationsSelector = createSelectorFromUtil(getOfferProductConfigurations, transformState);
export const nonReccuringProductConfigurationsSelector = createSelectorFromUtil(getNonRecurringProductConfigurations, transformState);